import { Routes, Route, Navigate } from "react-router-dom";

import AuthRoutes from "./AuthRoutes";
import PrivateRoutes from "./PrivateRoutes";

import Error from "../components/pages/Error";
import ComingSoon from "../components/pages/ComingSoon";
import AuthPage from "../components/pages/Auth";
import StudentsPage from "../components/pages/student";
import StudentResumeDetails from "../components/pages/student/resume/StudentResumeDetails";
import ResumeFullPreview from "../components/pages/student/resume/ResumeFullPreview";
import ScanDetailsPage from "../components/pages/student/resume/ScanDetails";
import StudentCoverLetter from "../components/pages/student/cover-letter/CoverLetter";
import CoverLetterFullPreview from "../components/pages/student/cover-letter/CoverLetterFullPreview";
import StudentPersonalPage from "../components/pages/student/personal/Edit";
import InterviewsList from "../components/pages/student/interviews/Index";
import InterviewDetails from "../components/pages/student/interviews/Details";
import SettingsPage from "../components/pages/Settings";
import VisaChances from "../components/pages/student/visa-chances";
import ChangeLogPage from "../components/pages/student/ChangeLog";
import ImmigrationPage from "../components/pages/Immigration";
import UserSignUpReport from "../components/pages/reports/UserSignUpReport";
import ActiveUserReport from "../components/pages/reports/ActiveUserReport";
import UserScoreReport from "../components/pages/reports/UserScore";
import InterviewReport from "../components/pages/reports/InterviewReport";
import ActiveUserDemographicsReport from "../components/pages/reports/ActiveUserDemographicsReport";
import UserJobsReport from "../components/pages/reports/UserJobsReport";
import CertificateAwardsReport from "../components/pages/reports/CertificateAwardsReport";
import UserVisitsReport from "../components/pages/reports/UserVisitsReport";
import PageViewsReport from "../components/pages/reports/PageViewsReport";
import ImmigrationHelp from "../components/pages/ImmigrationHelp";
import NotificationsPage from "../components/pages/student/Notifications";
import ChatsPage from "../components/pages/Chats";
import ResourcesListPage from "../components/pages/resources/Index";
import ResourceSavePage from "../components/pages/resources/Save";
import BannerSavePage from "../components/pages/banners/Save";
import BannersListPage from "../components/pages/banners/Index";

const NavigationRoutes = () => {
  return (
    <Routes>
      <Route element={<AuthRoutes />}>
        <Route path="/auth" element={<Navigate to="/auth/sign-in" replace />} />
        <Route path="/auth/:view" element={<AuthPage />} />
      </Route>
      <Route element={<PrivateRoutes />}>
        <Route path="/" element={<Navigate to="/students" replace />} />

        <Route path="/students" element={<StudentsPage />} />
        <Route path="/students/create" element={<StudentPersonalPage />} />
        <Route path="/students/:studentId/personal" element={<StudentPersonalPage />} />
        <Route path="/students/:studentId/resume" element={<StudentResumeDetails />} />
        <Route path="/students/:studentId/resume/:resumeId" element={<ResumeFullPreview />} />
        <Route path="/students/:studentId/scanner/:scannerId/details" element={<ScanDetailsPage />} />
        <Route path="/students/:studentId/cover-letter" element={<StudentCoverLetter />} />
        <Route path="/students/:studentId/cover-letter/:coverId" element={<CoverLetterFullPreview />} />
        <Route path="/students/:studentId/interviews" element={<InterviewsList />} />
        <Route path="/students/:studentId/interviews/:interviewId/details" element={<InterviewDetails />} />
        <Route path="/students/:studentId/visa-chances" element={<VisaChances />} />
        <Route path="/students/:studentId/immigration" element={<ImmigrationPage />} />
        <Route path="/students/:studentId/change-log" element={<ChangeLogPage />} />
        <Route path="/students/:studentId/notifications" element={<NotificationsPage />} />
        <Route path="/immigration-help" element={<ChatsPage />} />
        <Route path="/immigration-help/details/:id" element={<ImmigrationHelp />} />

        <Route path="/pr-options" element={<ComingSoon />} />
        <Route path="/visa-chances" element={<ComingSoon />} />

        <Route path="/resumes" element={<ComingSoon />} />
        <Route path="/interviews" element={<ComingSoon />} />
        <Route path="/linkedin" element={<ComingSoon />} />
        <Route path="/courses" element={<ComingSoon />} />
        <Route path="/reports/user-sign-up" element={<UserSignUpReport />} />
        <Route path="/reports/active-user" element={<ActiveUserReport />} />
        <Route path="/reports/user-scores" element={<UserScoreReport />} />
        <Route path="/reports/interviews-completed" element={<InterviewReport />} />
        <Route path="/reports/active-user-demographics" element={<ActiveUserDemographicsReport />} />
        <Route path="/reports/user-jobs" element={<UserJobsReport />} />
        <Route path="/reports/certificate-awards" element={<CertificateAwardsReport />} />
        <Route path="/reports/user-visits" element={<UserVisitsReport />} />
        <Route path="/reports/page-views" element={<PageViewsReport />} />
        <Route path="/career-help" element={<ComingSoon />} />

        <Route path="/resources" element={<ResourcesListPage />} />
        <Route path="/resources/create" element={<ResourceSavePage />} />
        <Route path="/resources/details/:resource_id" element={<ResourceSavePage />} />

        <Route path="/banners" element={<BannersListPage />} />
        <Route path="/banners/create" element={<BannerSavePage />} />
        <Route path="/banners/details/:banner_id" element={<BannerSavePage />} />

        <Route path="/support" element={<ComingSoon />} />
        <Route path="/settings" element={<SettingsPage />} />

      </Route>
      <Route path="*" element={<Error />} />
    </Routes>
  );
};

export default NavigationRoutes;
